export const name = "ENDS_WITH";
export const summary = `Checks if a \`STRING\` or \`BYTES\` value is the suffix of another value.`;
export const reference = `
## ENDS_WITH

Checks if a \`STRING\` or \`BYTES\` value is the suffix of another value.

\`\`\`
ENDS_WITH(value, suffix)
\`\`\`

### Description

Takes two \`STRING\` or \`BYTES\` values. Returns \`TRUE\` if \`suffix\`is a suffix of \`value\`.

This function supports specifying collation.


### Return type

\`BOOL\`


### Examples



\`\`\`
SELECT ENDS_WITH('apple', 'e') as example

/*---------*
 | example |
 +---------+
 | True |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
